import React from "react";
import { Box, Typography } from "@mui/material";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";

export default function GuideOptionRow({
  label,
  selected,
  disabled,
  onClick,
  palette,
}) {
  return (
    <Box
      role="button"
      tabIndex={disabled ? -1 : 0}
      onClick={disabled ? undefined : onClick}
      onKeyDown={
        disabled
          ? undefined
          : (e) => {
              if (e.key === "Enter" || e.key === " ") {
                e.preventDefault();
                onClick();
              }
            }
      }
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        px: 1.25,
        py: 1,
        borderRadius: "8px",
        border: `1px solid ${
          selected ? palette.selectedBorder : palette.chipBorder
        }`,
        backgroundColor: selected ? palette.selectedBg : "transparent",
        cursor: disabled ? "default" : "pointer",
        transition: "border-color 0.12s, background-color 0.12s",
        "&:hover": disabled ? undefined : { borderColor: palette.selectedBorder },
      }}
    >
      <Typography sx={{ fontSize: "13px", color: palette.textPrimary, flex: 1 }}>
        {label}
      </Typography>
      {selected && (
        <CheckRoundedIcon sx={{ fontSize: 16, color: palette.accent }} />
      )}
    </Box>
  );
}
